import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME, DependentTableNames, PROrdersParts, PRNAME } from './constants';
import { HromadnaObjednavka } from './store/types';

export const partsPurchaseOrderUrl = '/Servis/Reports/GetPartsPurchaseOrderReport';
export const coDealerPurchaseReportUrl = '/Nd/Reports/GetCodealerPurchaseReport';
export class PROrdersProvider extends BaseApi {
	constructor() {
		super(MODULE_API, NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PROrdersParts:
				return `/${this.area}/${PRNAME}/${PROrdersParts}Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		if (tableName === PROrdersParts) {
			return `/${this.area}/${PRNAME}/${PROrdersParts}Rows`;
		}
		throw new Error(`data for ${tableName} is not implemented yet`);
	}

	async savePROrderData(dto: any) {
		return this.post(`/${MODULE_API}/${NAME}/SavePROrder`, dto);
	}

	async defaultJfnd(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/defaultForJfnd?mioPzn=${filter.MioPzn}`, filter);
	}

	async hromadnaObjednavka(input: HromadnaObjednavka[]) {
		return this.post(`/${MODULE_API}/${NAME}/HromadnaObjednavka`, input);
	}

	async sendNotificationForPartsOrder(Id: number) {
		return this.post(`/${MODULE_API}/${NAME}/SendNotificationForPartsOrder?PROrderId=${Id}`);
	}

	async sendNotificationForPartsOrderStatus(id: number, emailStatusFlag: number) {
		return this.post(`/${MODULE_API}/${NAME}/SendNotificationForPartsOrderStatus?PROrderId=${id}&EmailStatusFlag=${emailStatusFlag}`);
	}

	async printPrOrderReceipt(id: number) {
		return this.post(`/${MODULE_API}/${NAME}/PrintPrOrderReceipt?PROrderId=${id}`);
	}

	async closePrOrder(id: number) {
		return this.post(`/${MODULE_API}/${NAME}/ClosePrOrder?PROrderId=${id}`);
	}

	async getPROrderPFX(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/GetPROrderPFX`, filter);
	}

	markReportAsPrinted(id: number, reportType: string) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${id}&reportType=${reportType}`);
	}

	uploadParts(fileList: any, prId: null | number, dodavatelId: null | number, orderType: null | string, warehouseId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${MODULE_API}/${NAME}/UploadParts?prId=${prId}&dodavatelId=${dodavatelId}&orderType=${orderType}&warehouseId=${warehouseId}`, file);
	}

	async importTripodOrders() {
		return this.fetch(`/${MODULE_API}/${NAME}/ImportTripodOrders`);
	}

	async savePartsPOGrid(data: object) {
		return this.post(`/${MODULE_API}/PROrdersParts/savePartsPOGrid`, data);
	}

	async createEdfsSalesOrder(id: number) {
		return this.post(`/${MODULE_API}/${NAME}/CreateEdfsSalesOrder?PROrderId=${id}`);
	}

	async approvePrOrder(id:number){
		return this.update(`/${MODULE_API}/${NAME}/ApprovePrOrder?prOrderId=${id}`);
	}

	async getSupplierType(id:number) {
		return this.fetch(`/${MODULE_API}/${NAME}/GetSupplierTypeId?supplierId=${id}`);
	}

	async isEdfsEnabled(warehouseId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/IsEdfsEnabled?warehouseId=${warehouseId}`);
	}

	async IsEdfsSubmited(poId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/IsEdfsSubmited?poId=${poId}`);
	}

	async EnableSubmit(poId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/EnableSubmit?poId=${poId}`);
	}

	async createEdfsSalesOrderForTripodOrder() {
		return this.post(`/${MODULE_API}/${NAME}/CreateEdfsSalesOrderForTripodOrder`);
	}

	async getBillToWHWiseShipToWH(billToWarehouseId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/GetBillToWHWiseShipToWH`, { billToWarehouseId });
	}
}

export const apiProvider = new PROrdersProvider();
